import styled, { css } from 'styled-components'

export const ProductsContainer = styled.div`
  background: #02e5ff;
`

export const ErrorMessage = styled.div`
  padding: 20px;
  width: 100%;
  background-color: #CCCCCC;
  margin: 0px 20px;
  @media (min-width: 768px) {
    margin: 0px 40px;
  }
  color: #D81313;
  font-weight: bold;
`

export const ProductsListing = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: ${({ isSubcategorySearch }) => isSubcategorySearch ? '0px' : '45px'};
  padding: 0;
  @media (min-width: 768px) {
    padding: 0 10px;
  }
`

export const WrapAllCategories = styled.div`
  background: #02e5ff;
  scroll-margin-top: 130px;
  .category-title {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding-top: 5px;
    padding-bottom: 12px;
    margin-left: 10px;
    ${props => props.theme?.rtl && css`
      margin-right: 10px;
      margin-left: 0;
    `}

    img {
      border-radius: 7.6px;
      min-width: 41px;
      min-height: 41px;
      height: 41px;
      width: 41px;
      margin-right: 10px;
      ${props => props.theme?.rtl && css`
        margin-left: 10px;
        margin-right: 0;
      `}
    }

    @media (min-width: 993px) {
      margin: 0px;
    }
  }

  h3 {
    font-size: 16px;
    font-family: 'Bebas Neue', sans-serif;
    font-weight: 400;
    color: #1e1e1e;
    text-transform: uppercase;
    margin: 25px 0px 15px 15px;
    letter-spacing: 1.5px;
    text-shadow: 0 0 6px rgba(0, 38, 255, 0.9), 0 0 20px rgba(255, 0, 127, 0.6);
    @media (min-width: 768px) {
      margin: 10px 0px 10px 10px;
      font-size: 28px;
    }
  };
    margin: 0px 0px 0px 10px;
    ${props => props.theme?.rtl && css`
      margin: 0px 10px 0px 0px;
    `}

    @media (min-width: 993px) {
      margin: 0px;
    }
  }
`

export const CategoryDescription = styled.div`
  margin-left: 15px;
    margin-bottom: 10px;
    display: flex;
    align-items: flex-end;
    p {
      margin: 0;
      color: ${props => props.theme?.colors.darkGray};
      white-space: pre;
      max-width: ${({ maxWidth }) => maxWidth ? `${maxWidth - 200}px` : 'initial'};
      overflow: hidden;
      text-overflow: ellipsis;
    }
    span {
      color: ${props => props.theme.colors.primary};
      margin-left: 10px;
      cursor: pointer;
      white-space: nowrap;
      &:hover {
        text-decoration: underline;
      }
    }
`

export const WrapperNotFound = styled.div`
  height: 500px;
  > div{
    height: 100%;
  }
`

export const HeaderWrapper = styled.div``

export const DescriptionModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 10px;
  img{
    border-radius: 7.6px;
    width: 200px;
    height: 200px;
    min-width: 200px;
    min-height: 200px;
    margin-bottom: 20px;
  }
`

export const DescriptionContainer = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  div{
    height: 300px;
    ::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
  }
  p{
    white-space: pre-wrap;
    overflow-wrap: break-word;
  }
`

export const RibbonBox = styled.div`
  padding: 2px 8px;
  box-sizing: border-box;
  color: ${props => props.theme.colors.colorTextSignForm};
  font-weight: 400;
  font-size: 10px;
  line-height: 13px;
  background-color: ${props => props.theme.colors.primary};
  max-width: 200px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  margin-left: 5px;

  ${props => props.theme.rtl && css`
    margin-left: 0px;
    margin-right: 5px;
  `}

  ${({ bgColor }) => bgColor && css`
    background-color: ${bgColor};
  `}

  ${({ isRoundRect }) => isRoundRect && css`
    border-radius: 7.6px;
  `}

  ${({ isCapsule }) => isCapsule && css`
    border-radius: 50px;
  `}
`

export const SubCategoriesContainer = styled.div`
  overflow: auto hidden;
  margin-top: 10px;
  width: 100%;
  ::-webkit-scrollbar {
      opacity: 0;
  }
  @media (min-width: 993px) {
    width: calc(100% - 30px);
  }
`

export const SubCategoriesInnerContainer = styled.div`
  display: flex;
`

export const ContainerButton = styled.div`
  button {
    white-space: nowrap;
    font-size: 14px;
    display: flex;
    align-items: center;
    overflow: hidden;
    margin-right: 10px;
    border-radius: 50px;

    svg {
      margin-left: 5px;
      font-size: 13px;
      ${props => props.theme.rtl && css`
        margin-right: 5px;
        margin-left: 0px;
      `}
    }
  }
`

export const SubcategorySearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  @media (min-width: 768px) {
    margin-left: 40px;
  }

  h4 {
    font-family: 'Anton', sans-serif;
    font-size: 22px;
    font-weight: 400;
    color: #FFF;
    text-transform: uppercase;
    text-shadow: 0 0 10px rgba(255, 0, 127, 0.8);
    margin: 10px 0 20px 0;
    letter-spacing: 1px;
  }
`

export const PreviouslyOrderedContainer = styled.div`
    display: flex;
    overflow: scroll hidden;
    ::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }
`

export const PreviouslyOrderedWrapper = styled.div`
  display: flex;
  box-sizing: border-box;

  .product-card {
    width: 270px;
    max-width: 270px;
  }

`

export const CartSectionContainer = styled.div`
  position: fixed;
  bottom: 0px;
  left: 0;
  width: 100%;
  background-color: #ff0090;
  border-top: 2px solid #0056ff;
  padding: 12px 15px;
  display: flex;
  flex-direction: column;
  z-index: 1100;
  box-sizing: border-box;
  box-shadow: 0 -8px 25px rgba(0, 0, 0, 0.9);

  @media (max-width: 576px) {
    bottom: 60px; /* Position above NavigationBar */
  }

  @media (min-width: 768px) {
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    max-width: 530px;
    border: 1px solid #222;
    border-top: 3px solid #0056ff;
    border-radius: 12px 12px 0 0;
    padding: 20px 30px;
    bottom: 0px;
  }

  .cart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #1a1a1a;
    padding-bottom: 15px;
    margin-bottom: 15px;
    gap: 12px;

    .cart-info {
      color: #FFF;
      font-weight: 400;
      font-family: 'Anton', sans-serif;
      font-size: 14px;
      text-transform: uppercase;
      letter-spacing: 1.2px;
      flex: 1;
      line-height: 1.2;

      @media (min-width: 768px) {
        font-size: 20px;
      }
    }

    .actions {
      display: flex;
      align-items: center;

      .plus-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 28px;
        height: 28px;
        border-radius: 50%;
        border: 1.5px solid #FFFF00;
        color: #FFF;
        margin-right: 12px;
        background-color: #000;
        cursor: pointer;
        font-size: 16px;
        box-shadow: 0 0 10px rgba(255, 255, 0, 0.4);
        transition: all 0.2s;

        @media (min-width: 768px) {
          min-width: 38px;
          height: 38px;
          font-size: 21px;
          margin-right: 20px;
        }

        &:hover {
          background-color: rgba(255, 255, 0, 0.1);
          transform: scale(1.05);
        }
      }

      .view-cart {
        background-color: #FFFF00;
        color: #000;
        border: none;
        border-radius: 20px;
        padding: 8px 16px;
        cursor: pointer;
        font-weight: bold;
        font-size: 13px;
        white-space: nowrap;
        box-shadow: 0 0 12px rgba(255, 0, 127, 0.3);
        transition: all 0.2s;

        @media (min-width: 768px) {
          padding: 10px 20px;
          font-size: 14px;
          border-radius: 25px;
        }

        &:hover {
          background-color: #e60072;
          transform: translateY(-1px);
          box-shadow: 0 4px 15px rgba(255, 0, 127, 0.5);
        }
      }
    }
  }

  .checkout-btn {
    background-color: #0066FF;
    color: #FFF;
    border: none;
    border-radius: 25px;
    padding: 10px 20px;
    cursor: pointer;
    font-weight: bold;
    width: 100%;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 1px;
    box-shadow: 0 0 15px rgba(0, 102, 255, 0.2);
    transition: all 0.2s;
    text-align: center;

    @media (min-width: 768px) {
      width: fit-content;
      padding: 12px 40px;
      font-size: 14px;
      text-align: left;
    }

    &:hover {
      background-color: #0052cc;
      transform: translateY(-1px);
      box-shadow: 0 4px 18px rgba(0, 102, 255, 0.4);
    }

    &:active {
      transform: scale(0.98);
    }
  }
`
